/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { PARSED_FACING_DATA_FRAGMENT } from './ParsedFacingDataFragment'

export const PARSED_SHELF_DATA_FRAGMENT = gql`
  fragment ParsedShelfData on ParsedShelfData {
    segmentShelfIndex
    displayShelfIndex
    facings {
      ...ParsedFacingData
    }
  }
  ${PARSED_FACING_DATA_FRAGMENT}
`
